import React from "react";
import PropTypes from "prop-types";
import CompactMetricCard from "src/components/InsightsPage/Cards/CompactMetricCard";

const LayersMetric = ({ metric, loading, targetChanged }) => {
  return (
    <CompactMetricCard
      icon={["far", "layer-group"]}
      title="Layers"
      current={metric.current}
      target={metric.target}
      deltaFormatted={metric.deltaFormatted}
      ragStatus={metric.ragStatus}
      loading={loading}
      targetChanged={targetChanged}
      totalOrgLayers={metric.totalOrgLayers}
    />
  );
};

LayersMetric.propTypes = {
  metric: PropTypes.shape({
    current: PropTypes.number,
    target: PropTypes.number,
    deltaFormatted: PropTypes.string,
    ragStatus: PropTypes.string,
    totalOrgLayers: PropTypes.number,
  }).isRequired,
  loading: PropTypes.bool,
  targetChanged: PropTypes.bool,
};

export default LayersMetric;
